import { ListSpacesRequest, ListSpacesResponse } from '@flatfile/api-internal/api'
import { AppHTTPService } from '../http-service'
import { Session } from '../types/Session'

type ListSessionsResponse = ListSpacesResponse & {
  data: Session[]
}

type GetSessionsRequestParams = ListSpacesRequest & {
  filterByEnvId: boolean
  app?: string
  isAppTemplate?: boolean
}

export const getSessions = async (requestParams: GetSessionsRequestParams): Promise<ListSessionsResponse> => {
  const { environmentId, filterByEnvId, ...paramsWithoutEnvironmentId } = requestParams
  const params = filterByEnvId ? { ...paramsWithoutEnvironmentId, environmentId } : paramsWithoutEnvironmentId
  return AppHTTPService.axios.get(`/v1/internal/spaces`, { params }).then((response) => response.data)
}
